import ApplicationChatView from './ApplicationChat.view';
export * from './ApplicationChat.view';

export const ApplicationChat = (props) => ApplicationChatView(props);

export default ApplicationChat;

